import { render, staticRenderFns } from "./EnquiryReservationFloatBtns.vue?vue&type=template&id=3c740b25&"
import script from "./EnquiryReservationFloatBtns.vue?vue&type=script&lang=js&"
export * from "./EnquiryReservationFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports